module.exports = __webpack_public_path__ + "img/zhengshu4-hui.89d9a977.png";